const Form002ATC = {
    stepName: {
        ImportantNotes: "重要提示",
        PersonalInfo: "校長資料",
        ServiceRecord: "服務紀錄",
        GainedRewards: "曾獲公益少年團功績榮譽獎",
        Confirmation: "確認",
    },
    label: {
        positionOption: {
            teacher: "教師",
            manager: "主任",
            vicePrincipal: "副校長",
            socialWorker: "社工",
            others: "其他",
        },
        positions: {
            chairman: "主席",
            viceChairman: "副主席",
            secretary: "秘書",
            cashier: "司庫",
            committee: "委員",
        },
        rewardOption: {
            appreciationFiveYear: "忠誠服務獎（已服務不少於五年）",
            appreciationSevenYear: "良好服務獎（已服務不少於七年）",
            appreciationTenYear: "優異服務獎（已服務不少於十年）",
            appreciationThirteenYear: "銅章（已服務不少於十三年）",
            appreciationSixteenYear: "銀章（已服務不少於十六年）",
            appreciationYear: "金章（由本團會長審核及頒贈）",
            noAppreciation: "本人未曾領取任何獎項",
        },
        titleOption: {
            Mr: "先生",
            Ms: "小姐",
            Mrs: "女士",
            Dr: "博士",
        },
        titleOptionE: {
            Mr: "Mr",
            Ms: "Ms",
            Mrs: "Mrs",
            Dr: "Dr.",
        },
        nomineeTitle: "校長稱謂",
        nomineeName: "校長姓名",
        position: "職銜",
        specify: "請註明：",
        schoolName: "學校",
        schoolAddress: "學校地址",
        schoolTel: "學校電話",
        schoolFax: "傳真號碼",
        district: "所屬分區",
        year: "截至",
        year1: "年度為止（以學年計算），本人擔任本團會員學校導師及校長合共_______年，當中不包括中斷年份。﹝例：如於2020年9月開始擔任，即填1年﹞",
        title2: "最近三年擔任本團分區執行委員會職務（在適當位置加「√」）",
        title3: "最近三年統籌區本活動記錄：",
        annual: "年度",
        activityName: "活動名稱",
        jobCategory: "工作性質（請填寫代表數字）：（1）總負責人；（2）協助",
        post: "職務",
        total: "合共",
        nomineeTitleE: "稱謂",
        nomineeNameE: "校長英文姓名",
        rewardYear: "獲獎年份",
        statement: "聲明",
    },
    errorMsg: {
        one: "該年度已填寫",
        min3: "請填寫最近三年統籌區本活動記錄",
    },
};
export default Form002ATC;
